import LayoutErrorPage from '@flatsy/core/Layout/ErrorPage'
import Separator from '@flatsy/core/Layout/Separator'
import { LayoutSeparator } from '@flatsy/core/Layout/Separator/Layout'
import { Body1, Header1 } from '@flatsy/core/MaterialUi/Typo'
import FlatsyTheme from '@flatsy/core/MuiTheme/flatsyTheme'
import i18n from '@flatsy/utils/translations'
import React, { useContext } from 'react'
import { FormContext, ReturnContextProps } from '../../Context'
import useStyles from './Style'
import { ComponentsProps } from './Type'

const NoBookableSlotPage: React.FC<ComponentsProps> = ({ paramsUrl }) => {
  const classes = useStyles()
  const {
    wizardContext: { context },
    saveApplicationInRedux,
  } = useContext(FormContext) as ReturnContextProps
  const handleEvent = () => {
    saveApplicationInRedux({
      ...context.application,
      booking_wanted_date: '',
      booking_wanted_time: '',
      asset: paramsUrl,
    })
  }

  return (
    <LayoutErrorPage
      title={
        <div className={classes.container}>
          <Header1 align="center" lowerCase>
            {i18n.t('hello')}
          </Header1>
          <Separator size="16px" />
          <Body1 align="center">{i18n.t('property_has_currently_no_available_time_slots')}</Body1>
          <LayoutSeparator className={classes.line} />
          <Body1 align="center">{i18n.t('get_head_start_by_signing_up_via_button_below')}</Body1>
        </div>
      }
      text=""
      image={FlatsyTheme.image.waiting}
      buttonLabel={i18n.t('ask_for_a_tour')}
      event={handleEvent}
    />
  )
}

export default NoBookableSlotPage
